import { render, staticRenderFns } from "./ScheduleRoomControl.vue?vue&type=template&id=6b4eb26a&scoped=true"
import script from "./ScheduleRoomControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScheduleRoomControl.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ScheduleRoomControl.vue?vue&type=style&index=0&id=6b4eb26a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4eb26a",
  null
  
)

export default component.exports